import axios from "axios";

import { showGlobalNotification } from '../components/NotificationContext';

export function fetchRoutes(params = {}) {
    return axios.get('/lsystem/api/v1/drives-in-route', {params: params})
        .catch((error) => {
            const msg = extractErrorMessage(error) || 'Ошибка при получении маршрутов';
            if (typeof showGlobalNotification === 'function') {
                showGlobalNotification(msg, 'error');
            } else {
                alert(msg);
            }
            throw error;
        });
}

function extractErrorMessage(error) {
    if (error.response && error.response.data) {
        return error.response.data.message || error.response.data.error;
    } else if (error.message) {
        return error.message;
    }
    return 'Network or unknown error';
}

export function updateRoute(params = {}) {
    //Адаптер для старого апи
    const route = params.route.map((driveInRoute) => (
        {data: driveInRoute.drive, courier: driveInRoute.courier}
    ))
    return axios.put('/lsystem/api/v1/drives-in-route/' + params.routeId, {route: route, date: params.date})
        .catch((error) => {
            const msg = extractErrorMessage(error) || 'Ошибка при обновлении маршрута';
            if (typeof showGlobalNotification === 'function') {
                showGlobalNotification(msg, 'error');
            } else {
                alert(msg);
            }
            throw error;
        });
}

export function createRoute(params = {}) {
    //Адаптер для старого апи
    const route = params.route.map((driveInRoute) => (
        {data: driveInRoute.drive, courier: driveInRoute.courier}
    ))
    return axios.post('/lsystem/api/v1/drives-in-route', {date: params.date, route: route})
        .catch((error) => {
            const msg = extractErrorMessage(error) || 'Ошибка при создании маршрута';
            if (typeof showGlobalNotification === 'function') {
                showGlobalNotification(msg, 'error');
            } else {
                alert(msg);
            }
            throw error;
        });
}

/**
 * Получить список доступных шторных курьеров для помощника в той же смене
 * @param {Object} params - Параметры запроса
 * @param {number} params.helperCourierId - ID курьера-помощника
 * @param {string} params.date - Дата смены (YYYY-MM-DD)
 * @returns {Promise}
 */
export function getAvailableCurtainCouriers(params = {}) {
    return axios.get('/lsystem/app/api/v1/route-helper/available-curtain-couriers', {
        params: {
            helper_courier_id: params.helperCourierId,
            date: params.date
        }
    });
}

/**
 * Присвоить маршрут шторного курьера помощнику шторного
 * @param {Object} params - Параметры запроса
 * @param {number} params.helperCourierId - ID курьера-помощника
 * @param {number} params.mainCourierId - ID шторного курьера (опционально, если не указан - бэкенд выберет автоматически)
 * @param {string} params.date - Дата смены (YYYY-MM-DD, опционально, если не указана - берется текущая дата)
 * @returns {Promise}
 */
export function assignRouteToHelper(params = {}) {
    const requestData = {
        helper_courier_id: params.helperCourierId
    };
    if (params.mainCourierId) {
        requestData.main_courier_id = params.mainCourierId;
    }
    if (params.date) {
        requestData.date = params.date;
    }
    return axios.post('/lsystem/app/api/v1/route-helper/assign', requestData);
}

/**
 * Удалить маршрут у помощника шторного
 * @param {Object} params - Параметры запроса
 * @param {number} params.helperCourierId - ID курьера-помощника (обязательный, path parameter)
 * @param {number} params.routeId - ID маршрута (опционально, query parameter)
 * @param {string} params.date - Дата смены (YYYY-MM-DD, опционально, query parameter)
 * @returns {Promise}
 */
export function removeRouteFromHelper(params = {}) {
    const queryParams = {};
    if (params.routeId) {
        queryParams.route_id = params.routeId;
    }
    if (params.date) {
        queryParams.date = params.date;
    }
    const queryString = Object.keys(queryParams).length > 0 
        ? '?' + new URLSearchParams(queryParams).toString()
        : '';
    return axios.delete(`/lsystem/app/api/v1/route-helper/assign/${params.helperCourierId}${queryString}`);
}